
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/alquilerdeequiposdeesqui",
      function () {
        return require("private-next-pages/[region]/[resort]/alquilerdeequiposdeesqui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/alquilerdeequiposdeesqui"])
      });
    }
  